import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import React, { useEffect, useRef, useState } from "react";
import { Text, TextInput, TouchableOpacity, View } from "react-native";

import HeaderTabs from "../../components/HeaderTabs";

import balanceService from "../../services/balanceService";
import styles from "./styles";
import activesService from "../../services/activesService";
import { FormattedMessage } from "react-intl";
import GoBackButton from "../../components/GoBackButton";

const Certificates = ({ navigation, route }) => {
  const ref = useRef(null);
  const [value, setValue] = useState(0);
  const [cryptoQuantity, setCryptoQuantity] = useState(null);
  const [valueToken, setValueToken] = useState(0);
  const [year, setYear] = useState(+new Date().getFullYear() + "");
  const [balance, setBalance] = useState(0);
  const [endorsed, setEndorsed] = useState("");
  const [isEndorser, setIsEndorser] = useState("");
  const isFocused = useIsFocused();
  const certType = route.params?.certType || "compensation";
  const isOwnershipCert = certType === "ownership";
  console.log("certType:", certType);
  console.log("isOwnershipCert:", isOwnershipCert);
  const [active, setActive] = useState();

  useEffect(() => {
    async function loadEnderser() {
      const ie = await AsyncStorage.getItem("is_endorser");
      setIsEndorser(ie == "true");
    }
    loadEnderser();
  }, []);

  useEffect(() => {
    //  getCategories();
  }, [isFocused]);

  useEffect(() => {
    // let number = 0;
    // number = Math.ceil(  // round to nearest integer
    //     Number(value / 1000)    // type cast your input
    // );
    //if (number % 2 != 0 || number == 0)
    //    number++;
    setValueToken(value);
  }, [value]);

  useEffect(() => {
    if (route.params.id) {
      loadBalance();
      loadById();
    }
  }, [route.params]);

  const loadBalance = async () => {
    const authToken = await AsyncStorage.getItem("JWT_TOKEN");
    balanceService
      .getBalanceOfToken(authToken, route.params.id)
      .then((response) => {
        setBalance(parseFloat(response?.data?.saldo + ""));
      })
      .catch((error) => {});
  };

  const loadById = async () => {
    const authToken = await AsyncStorage.getItem("JWT_TOKEN");
    activesService.getById(authToken, route.params.id).then((response) => {
      if (response.data?.actives?.length > 0) {
        setActive(response.data.actives[0]);
      }
    });
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="certificates.tituloCertificados" />}
        iconLeft={"keyboard-arrow-left"}
        routeLeft={"MyAccount"}
        subtitle={<FormattedMessage id="certificates.emissaoCertificado" />}
        style={{ marginBottom: 0 }}
      />

      <View style={styles.container}>
        <Text style={styles.cardTitle}>
          <FormattedMessage id="certificatesemit.emissaoCertificadoSingular" />
        </Text>
        {!route.params?.cryptoactive && (
          <>
            <Text style={styles.label}>
              <FormattedMessage id="certificates.digiteQuantidadeTokens" />
            </Text>

            <FormattedMessage id="certificates.digiteQuantidade">
              {(placeholder) => (
                <TextInput
                  value={value}
                  placeholder={placeholder}
                  style={styles.input}
                  autoCapitalize="none"
                  keyboardType="numeric"
                  onChangeText={(val) => setValue(val.replace(/[^0-9]/g, ""))}
                ></TextInput>
              )}
            </FormattedMessage>
          </>
        )}

        {value.length > 0 ? (
          <Text style={{ fontSize: 14, color: "#077A97" }}>
            {<FormattedMessage id="certificates.voceUtilizando" />}
            {valueToken}

            {<FormattedMessage id="certificates.tokens" />}
          </Text>
        ) : (
          route.params?.cryptoactive && (
            <Text style={{ fontSize: 14, color: "red" }}>
              {<FormattedMessage id="certificates.digiteQuantidadeTokens" />}
            </Text>
          )
        )}
        {active?.certificate_question_year && !isOwnershipCert && (
          <>
            <Text style={styles.label}>
              {<FormattedMessage id="certificates.digiteAno" />}
            </Text>
            <TextInput
              value={year}
              placeholder={"Ex. 2019, 2020, 2021..."}
              style={styles.input}
              autoCapitalize="none"
              keyboardType="numeric"
              maxLength={4}
              defaultValue={new Date().getFullYear()}
              onChangeText={(val) => setYear(val.replace(/[^0-9]/g, ""))}
            ></TextInput>
            {year.length > 0 ? (
              parseInt(year) < 2010 ||
              parseInt(year) > new Date().getFullYear() ? (
                <Text style={{ fontSize: 14, color: "#077A97" }}>
                  {<FormattedMessage id="certificates.confirmaAno" />}
                  {year}?
                </Text>
              ) : (
                <></>
              )
            ) : (
              <Text style={{ fontSize: 14, color: "red" }}>
                {<FormattedMessage id="certificates.digiteOAno" />}
              </Text>
            )}
          </>
        )}

        {isEndorser && (
          <>
            <Text style={styles.label}>
              <FormattedMessage id="certificates.endossoPara" />
            </Text>

            <FormattedMessage id="certificates.digiteNomeEndossadoSeExistir">
              {(placeholder) => (
                <TextInput
                  value={endorsed}
                  placeholder={placeholder}
                  style={styles.input}
                  autoCapitalize="none"
                  onChangeText={(val) => setEndorsed(val)}
                ></TextInput>
              )}
            </FormattedMessage>
          </>
        )}

        {((route.params?.cryptoactive && cryptoQuantity) ||
          (value && valueToken)) &&
        ((active?.certificate_question_year && year) ||
          !active?.certificate_question_year) ? (
          balance >= valueToken ? (
            <View style={styles.contentBtn}>
              <TouchableOpacity
                onPress={() =>
                  navigation.navigate({
                    name: "CertificateEmit",
                    params: {
                      qtd: valueToken,
                      idCoin: route.params.id,
                      volume: value,
                      year: year,
                      year: isOwnershipCert
                        ? new Date().getFullYear().toString()
                        : year,
                      endorsed: endorsed,
                      cryptoQuantity,
                      cryptoactive: route.params.cryptoactive,
                      certType,
                    },
                  })
                }
                style={styles.btn}
              >
                <Text style={styles.textBtn}>
                  {<FormattedMessage id="certificates.emitirCertificado" />}
                </Text>
              </TouchableOpacity>
            </View>
          ) : (
            <TouchableOpacity style={styles.btn} route={"DepositMethod"}>
              <Text style={styles.textBtn}>
                <FormattedMessage id="certificates.saldoInsuficiente" />
              </Text>
            </TouchableOpacity>
          )
        ) : (
          <TouchableOpacity disabled={true} style={styles.btn}>
            <Text style={styles.textBtn}>
              <FormattedMessage id="certificates.preenchaCampos" />
            </Text>
          </TouchableOpacity>
        )}
        <View style={{ marginTop: 20, maxWidth: 320 }}>
          <GoBackButton style={{ maxWidth: 300 }} />
        </View>
      </View>
    </>
  );
};

export default Certificates;
